import { FormattedMessage } from 'react-intl';

import type { StatusBannerAutoHideProps } from '@xing-com/banner';

import { Styled } from './styles';

const ErrorStatusBanner: React.FC<Partial<StatusBannerAutoHideProps>> = ({
  show,
  handleOnClose,
}) => {
  return (
    <Styled.StatusBannerFixedContainer>
      <Styled.StatusBanner
        display="inline"
        variant="error"
        show={show}
        handleOnClose={handleOnClose}
        timeout={5000}
        data-qa="article-viewer-error-banner"
      >
        <FormattedMessage id="ARTICLES_ARTICLE_VIEWER_ERROR_MESSAGE" />
      </Styled.StatusBanner>
    </Styled.StatusBannerFixedContainer>
  );
};

export default ErrorStatusBanner;
